module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-right/icon-arrow-right-03d915ec8d54b20802ce0eaef4d762cb.svg";